<template>
  <div id="page">
    <!-- <router-link to="/blogs">Blogs</router-link> --> 
    <div class="container">
      <nav
        id="navbar_container"
        class="navbar fixed-top navbar-expand-md"
      >
        <a
          class=navbar-brand
          href="#Profile"
        >
          Dang Tran
        </a>
        <div class="collapse navbar-collapse">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a
                class="nav-link"
                href="#Profile"
              >Home</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="#News"
              >News</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="#Publications"
              >Publications</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="#Experiences"
              >Experiences</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="#Projects"
              >Projects</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="blogs"
              >Blogs</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="#Contact"
              >Contact</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                v-bind:href="github_link"
              >Github</a>
              <!-- TODO: Add icon for the github instead -->
            </li>
          </ul>
        </div>
      </nav>
    </div>

    <div class="container">

      <!-- !Profile -->
      <div
        id="Profile"
        class="container"
      >
        <div class="row">
          <div
            id="profile_image"
            class="col-md-3"
          >

            <div class="avatar-wrapper">
              <div class="avatar-container">
                <img
                  v-bind:src="avatar"
                  alt=""
                  class="img-fluid center"
                />
              </div>
              <h2 class="mb-0 mt-0 text-center">Dang Tran</h2>
              <p class="mb-0 mt-0 text-center">Ph.D Candidate</p>
              <p class="mb-0 mt-0 text-center">Computer Science</p>
              <p class="mb-0 mt-0 text-center">University of Alabama</p>
              <p class="mb-0 mt-0 text-center">dmtran1@crimson.ua.edu</p>
              <p class="mb-0 mt-0 text-center">Contact: SERC 2023 or CyberHall 3013  </p>
               
              <p class="mb-0 mt-0 text-center">

                <a v-bind:href="googlescholar_link">
                    <v-icon type="mdi" :path="googlescholar_path">
                    </v-icon>
                </a>
                <a v-bind:href="github_link">
                    <v-icon type="mdi" :path="github_path">
                    </v-icon>
                </a>
                <a v-bind:href="linkedin_link">
                  <v-icon type="mdi" v-bind:path="linkedin_path"></v-icon>
                </a>

                <a v-bind:href="orcid_link">
                  <img v-bind:src="orcid_icon"
                    width="20" 
                    height="20"
                  >
                </a>
                
              </p>
            </div>
          </div>

          <div class="col-md-9">
            <span class="home_title">Hi! My name is Dang Tran.</span>
            <p>
              I am a Ph.D. candidate in Computer Science at the University of Alabama (UA), under
              supervision of <a v-bind:href="hongsheng_he_link">Dr. Hongsheng He</a>.
              I hold a Bachelor's degree in Computer Science with a minor in Mathematics from Wichita State
              University, Kansas.
            </p>
            <p>
              My dissertation focuses on advancing Natural Language Processing (NLP) applications in robotics. 
              Specifically, I am developing innovative NLP pipelines that enable robots to comprehend and 
              execute complex human commands. My research integrates both knowledge-based systems and 
              cutting-edge data-driven solutions, pushing the boundaries of human-robot interaction.
            </p>
            <p>
              As a Graduate Research Assistant in the Intelligent Robot Lab (IRL) at The University of Alabama,
              I have gained extensive experience in academic research and the development of advanced robotic platforms. 
              My work involves creating sophisticated robotic frameworks and implementing deep learning-based solutions. 
              I possess a comprehensive skill set encompassing machine learning, artificial intelligence, robot simulation, and control systems.
            </p>
            <p>
              Some robotic frameworks that I fortunately have experienced with:
            <ol>
              <li>UR5e</li>
              <li>Husky</li>
              <li>Leo Rover</li>
              <li>Sawyer</li>
              <li>FANUC LRMate</li>
              <li>Nao</li>
            </ol>
            </p>
          </div>
        </div>

      </div>

      <!-- !News -->
      <div class="container">
        <h3 id="News">News</h3>
        <hr>

        <div class="row">
          <div class="col-md-3">
            <p>
              <b>Jan 2026</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              Our Journal paper titled "HiP-CL: High-Level Planning Based on Common Language for Multi-Robot Teaming" is accepted and available at <b> <a href="https://link.springer.com/article/10.1007/s44230-025-00130-5"> Human-Centric Intelligent Systems (HCIS, Springer)</a> </b>.
            </p>
          </div>
        </div>
        <br>


        <div class="row">
          <div class="col-md-3">
            <p>
              <b>August 2025</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              I am honored and grateful to receive <b>2nd</b> time the 
              prestigious grant from <a v-bind:href="grsp_link">Alabama EPSCOR GRSP</a> (Graduate Research Scholars Program) for the year 2025.
            </p>
          </div>
        </div>
        <br>


        <div class="row">
          <div class="col-md-3">
            <p>
              <b>April 1st 2025</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              I have received the prestigious <b>Outstanding Graduate Student Award</b> at the University of Alabama for the year 2025.
            </p>
          </div>
        </div>
        <br>



        <div class="row">
          <div class="col-md-3">
            <p>
              <b>Jan 2025</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              Our Conference paper titled "Controlled Robot Language with Frame semantics (FrameCRL) for Autonomous Context-Aware High-level Planning" is accepted at <b> <a href="https://ieeexplore.ieee.org/abstract/document/11127391">  IEEE International Conference on Robotics and Automation (ICRA) </a> </b>  2025, taking place in Atlanta, May 2025.
            </p>
          </div>
        </div>
        <br>

        <!-- <div class="row">
          <div class="col-md-3">
            <p>
              <b>June 2023</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              Get admission in University of Alabama Graduate program!
            </p>
          </div>
        </div>
        <br> -->
        <div class="row">
          <div class="col-md-3">
            <p>
              <b>September 2024</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              Our 2 Conference papers titled "Complex instruction translation using fine-tuned large language models" and "Autonomous multi-robot action planning through controlled robot language" are accepted at 16th International Conference on Social Robotics (ICSR) + InnoBiz (2024)
            </p>
          </div>
        </div>
        <br>

        <div class="row">
          <div class="col-md-3">
            <p>
              <b>August 2024</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              I am honored and grateful to have been awarded the 
              prestigious grant from <a v-bind:href="grsp_link">Alabama EPSCOR GRSP</a> (Graduate Research Scholars Program) for the year 2024.
            </p>
          </div>
        </div>
        <br>

        <div class="row">
          <div class="col-md-3">
            <p>
              <b>October 2023</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              Our Conference paper is accepted at International Conference Social Robotics 2023 (ICSR 2023).
            </p>
          </div>
        </div>
        <br>

        <div class="row">
          <div class="col-md-3">
            <p>
              <b>September 2023</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              Our Conference paper is accepted at International Conference on Humanoid Robots 2023. 
            </p>
          </div>
        </div>
        <br>

        <div class="row">
          <div class="col-md-3">
            <p>
              <b>August 2023</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
                Getting accepted to a Ph.D program at University of Alabama. 
            </p>
          </div>
        </div>
        <br>


        <div class="row">
          <div class="col-md-3">
            <p>
              <b>May 2023</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              Our Journal paper is accepted at IEEE Transaction Instrument and Measurement (TIM) 2023.
            </p>
          </div>
        </div>
        <br>

        <!-- 
          <div class="row">
          <div class="col-md-3">
            <p>
              <b>January 2023</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              Getting accepted to a Ph.D program at WSU.
            </p>
          </div>
        </div>
        <br> 
        -->

        <div class="row">
          <div class="col-md-3">
            <p>
              <b>December 2022</b>
            </p>
          </div>

          <div class="col-md-9">
            <p>
              Complete B.S program at WSU.
            </p>
          </div>
        </div>
      </div>
      <br>

      <!-- !Publications -->
      <div
        id="Publications"
        class="container"
      >
        <h3>Publications</h3>
        <hr>

       <!-- !Publication -->
       <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/papers/HCIS_redraw.png`)"
            />

          </div>
          <div class="col-md-9">
            <!-- Dang Tran, Minhazul Arefin, Bineet Ghosh, Amir Rahmani, Hongsheng He -->
            <p> <span id="author">Dang Tran</span>, <a v-bind:href="minhazul_link">Minhazul Arefin</a>, <a v-bind:href="bineet_link"> Bineet Ghosh</a>, Amir Rahmani, and <a v-bind:href="hongsheng_he_link">Hongsheng He</a> (2025)</p>
            <b>HiP-CL: High-Level Planning Based on Common Language for Multi-Robot Teaming</b>
            <p>Human-Centric Intelligent Systems (HCIS), Springer, 2025</p>
            <p>Springer 2025</p>
          </div>
        </div>
        <br>

        <!-- !Publication -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/papers/ICRA_2025.png`)"
            />

          </div>
          <div class="col-md-9">
            <p> <span id="author">Dang Tran</span>, <a v-bind:href="fujian_link">Fujian Yan</a>, Qiang Zhang, Yinlong Zhang, and <a v-bind:href="hongsheng_he_link">Hongsheng He</a> (2024)</p>
            <b>Controlled Robot Language with Frame semantics (FrameCRL) for Autonomous Context-Aware High-level Planning</b>
            <p>IEEE International Conference on Robotics and Automation (ICRA) 2025 (Atlanta)</p>
            <p>ICRA 2025</p>
          </div>
        </div>
        <br>


        <!-- !Publication -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/papers/ICSR_2024.png`)"
            />

          </div>
          <div class="col-md-9">
            <p> <span id="author">Dang Tran</span>, Minhazul Arefin, Zhengchen Zhang, and <a v-bind:href="hongsheng_he_link">Hongsheng He</a> (2024)</p>
            <b>Autonomous Multi-Robot Action Planning through Controlled Robot Language</b>
            <p>ICSR InnoBiz 2024 (Shenzhen)</p>
            <p>International Conference of Social Robotics 2024</p>
          </div>
        </div>
        <br>


        <!-- !Publication -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/papers/ICSR_2023.png`)"
            />

          </div>
          <div class="col-md-9">
            <p> <span id="author">Dang Tran</span>, <a v-bind:href="hui_link">Hui Li</a>, and <a v-bind:href="hongsheng_he_link">Hongsheng He</a> (2023)</p>
            <b>AI Planning From Natural-Language Instructions for Trustworthy Human-Robot Communication</b>
            <p>ICSR 2023 (Doha)</p>
            <p>International Conference of Social Robotics 2023</p>
          </div>
        </div>
        <br>

        <!-- !Publication -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/papers/IEEE-RAS_2023.png`)"
            />

          </div>
          <div class="col-md-9">
            <p> <a v-bind:href="hui_link">Hui Li</a>, <span id="author">Dang Tran</span>, Xinyu Zhang, and <a v-bind:href="hongsheng_he_link">Hongsheng He</a> (2023)</p>
            <b>Knowledge Augmentation and Task Planning in Large Language Models for Dexterous Grasping</b>
            <p>2023 IEEE-RAS 22nd</p>
            <p>International Conference on Humanoid Robots (Humanoids)</p>
          </div>
        </div>
        <br>


        <!-- !Publication -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/papers/IEEE_TIM_2023.png`)"
            />

          </div>
          <div class="col-md-9">
            <p> <span id="author">Dang Tran</span>, Nate Ahlgren, Chris Depcik, and <a v-bind:href="hongsheng_he_link">Hongsheng He</a> (2023)</p>
            <b>Adaptive Active Fusion of Camera and Single-Point
              LiDAR for Depth Estimation</b>
            <p>IEEE TIM 2023</p>
            <p>IEEE Transactions on Instrumentation and Measurement 2023</p>
          </div>
        </div>
        <br>

        <!-- !Publication -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/papers/ICSR_2021.png`)"
            />
          </div>
          <div class="col-md-9">
            <p> <span id="author">Dang Tran</span>, <a v-bind:href="fujian_link">Fujian Yan</a>, Yimesker Yihun, Jindong Tan, and <a v-bind:href="hongsheng_he_link">Hongsheng He</a> (2021)</p>
            <b>A Framework of Controlled Robot Language for
              Reliable Human-Robot Collaboration</b>
            <p>ICSR2021</p>
            <p>International Conference of Social Robotics 2021</p>
          </div>
        </div>
        <br>

        <!-- !Publication -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/papers/International Journal of Social Robotics 2020.png`)"
            />
          </div>
          <div class="col-md-9">
            <p> <a v-bind:href="fujian_link">Fujian Yan</a>, <span id="author">Dang Tran</span> and <a v-bind:href="hongsheng_he_link">Hongsheng He</a> (2020)</p>
            <b>Robotic Understanding of Object Semantics by Referring to a Dictionary</b>
            <p>International Journal of Social Robotics 2020</p>
          </div>
        </div>
      </div>

      <br>

      <!-- !Experiences -->
      <div
        id="Experiences"
        class="container"
      >
        <h3>Experiences</h3>
        <hr>

        <!-- !Experience  -->
        <div class="row">
          <div class="col-md-3">
            <p>
              Since Sep 2023
            </p>
          </div>
          <div class="col-md-9">
            <p>Graduate Research Assistant</p>
            <b> Intelligent Robot Laboratory (IRL), The University of Alabama,
              Tuscaloosa, Alabama</b>
          </div>
        </div>
        <br>


        <!-- !Experience  -->
        <div class="row">
          <div class="col-md-3">
            <p>
              Jul 2018 - Aug 2023
            </p>
          </div>
          <div class="col-md-9">
            <p>Research Assistant</p>
            <b> Robot Intelligence Laboratory (RIL), Wichita State University (WSU),
              Wichita, Kansas</b>
          </div>
        </div>
        <br>

        <!-- !Experience  -->
        <div class="row">
          <div class="col-md-3">
            <p>
              Nov 2021 - Dec 2022
            </p>
          </div>
          <div class="col-md-9">
            <p>Research Assistant in Robotics</p>
            <b> National Institute for Aviation Research (NIAR), Wichita,
              Kansas</b>
          </div>
        </div>
        <br>
      </div>
      <br>

      <!-- !Projects -->
      <div
        id="Projects"
        class="container"
      >
        <h3>Projects</h3>
        <hr>

        <!-- !Robotics Projects -->
        <h4>Robotics</h4>
        <!-- !Project -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/personal_projects/project_nlp_robot.png`)"
              alt=""
            >
          </div>
          <div class="col-md-9">
            <b> Integrate NLP framework to Robotic Controls</b>
          </div>
        </div>
        <br>

        <!-- !Project -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/projects/multi_robot_collaboration.png`)"
              alt=""
            >
          </div>
          <div class="col-md-9">
            <b> Multi-robot high-level collaboration</b>
          </div>
        </div>
        <br>

        <!-- !Project -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/personal_projects/project_CAD2Path.png`)"
              alt=""
            >
          </div>
          <div class="col-md-9">
            <b> Develop CAD2Path program with C++ & Roboguide (Fanuc LRMate)</b>
          </div>
        </div>
        <br>

        <!-- !Project -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/personal_projects/project_knowledge_based_planning.png`)"
              alt=""
            >
          </div>
          <div class="col-md-9">
            <b> Knowledge-based Planning for Robotic Controls</b>
          </div>
        </div>
        <br>

        <!-- !Project -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/personal_projects/project_mobile.png`)"
              alt=""
            >
          </div>
          <div class="col-md-9">
            <b> Control Mobile Robot (Voltage) with Finite-State-Machine </b>
          </div>
        </div>
        <br>

        <!-- !Project -->
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid img-rounded"
              v-bind:src="require(`@/assets/personal_projects/project_pybullet.png`)"
              alt=""
            >
          </div>
          <div class="col-md-9">
            <b> Reinforcement Learning with OpenAI Gym and Pybullet</b>
          </div>
        </div>
        <br>

        <!-- ~ <div class="row"> -->
        <!-- ~ <div class="col-md-3"> -->
        <!-- ~  -->
        <!-- ~ </div> -->
        <!-- ~ <div class="col-md-9"> -->
        <!-- ~ <b> Integrate Gym with Gazebo</b> -->
        <!-- ~ </div> -->
        <!-- ~ </div> -->
        <!-- ~ <br> -->

        <!-- !NLP Projects -->
        <!-- <h4>NLP</h4> -->
        <!--  -->
        <!-- <div class="row"> -->
        <!-- <div class="col-md-3"> -->
        <!-- </div> -->
        <!-- <div class="col-md-9"> -->
          <!-- <b> Develop various NLP Parsing Algorithms</b> -->
        <!-- </div> -->
        <!-- </div> -->
        <!-- <br> -->
        <!--  -->
        <!-- <div class="row"> -->
        <!-- <div class="col-md-3"> -->
        <!-- </div> -->
        <!-- <div class="col-md-9"> -->
          <!-- <b> Develop Planning Parser + Information Extraction</b> -->
        <!-- </div> -->
        <!-- </div> -->
        <!-- </div> -->
        <!-- <br> -->

      <!-- !Contact -->
      <div
        id="Contact"
        class="container"
      >
        <h3>Contact</h3>
        <hr>
        Robot Intelligence Laboratory
        <br>
        South Engineering Research Center
        <br>
        Shelby Ln
        <br>
        Tuscaloosa, AL, USA, 35401
        <br>
        dmtran1@crimson.ua.edu
      </div>
      <br>

      <!-- !Footer -->
      <div class="container">
        <hr>
        © Dang Tran {{new Date().getFullYear()}}
        <br>
        <div class="row">

          <a
            class="text-right"
            href="https://clustrmaps.com/site/1burj"
            title="Visit tracker"
          ><img src="//clustrmaps.com/map_v2.png?cl=ffffff&w=a&t=n&d=nqSdGdWo5nS40pWlJuHEbV_ZUYx94S6A3saD0hvG1zM" /></a>
        </div>
      </div>

    </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

import Navigation from "./Navigation.vue";

import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLinkedin, mdiAccountSchoolOutline, mdiGithub } from "@mdi/js";

export default {
  name: "Home",
  components: {
    Navigation,
    "v-icon": SvgIcon,
  }, //
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  mounted() {
    document.title = "Dang Homepage";
  },
  data() {
    return {
      picture: info.flat_picture,
      description: info.description,
      name: "Dang Tran",
      avatar: require("../assets/avatar/avatar_Feb_2026.jpg"),
      orcid_icon: require("../assets/icons/32px-ORCID_iD.png"),
      orcid_link: "https://orcid.org/0000-0001-6394-1500",

      fujian_link:
        "https://www.wichita.edu/profiles/academics/engineering/SoC/Yan-Fujian.php",
      minhazul_link: "https://sites.google.com/view/minhazul-arefin/",
      hui_link: "https://scholar.google.com/citations?user=hgdrfuYAAAAJ&hl=en",
      bineet_link: "https://eng.ua.edu/eng-directory/dr-bineet-ghosh/",
      hongsheng_he_link: "https://eng.ua.edu/eng-directory/dr-hongsheng-he/",
      grsp_link: "https://alepscor.org/scholars-program/",

      linkedin_path: mdiLinkedin,
      linkedin_link: "https://www.linkedin.com/in/dang-tran-42a56112a/",
      googlescholar_path: mdiAccountSchoolOutline,
      googlescholar_link:
        "https://scholar.google.com/citations?user=0zwTD18AAAAJ&hl=en",

      github_path: mdiGithub,
      github_link: "https://github.com/DangMinh24",
    };
  },
};
</script>

<style scoped>
#page {
  /* background-color: rgb(24, 26, 27);
  color: white; */
  /* Warm Minimalist darkmode
  
    background:
      #1C1C1C -- 28, 28, 28
    text:
      #F5E8D8 -- 245, 232, 216
  */
  background-color: rgb(28, 28, 28);
  color: rgb(245, 232, 216);
}
#navbar_container {
  /* background-color: rgb(18, 44, 86); */
  padding-left: 40px;
  padding-right: 10px;
  /* Warm Minimalist darkmode
  
    background:
      #1B1B1B -- 27, 27, 27
    text:
      #F5E8D8 -- 245, 232, 216
  */
  background-color: rgb(18, 44, 86);
  color: rgb(245, 232, 216);
}

.navbar-brand {
  color: white;
}

.nav-link {
  color: white;
}

.navbar-brand:hover {
  color: rgb(224, 231, 14);
}
.nav-link:hover {
  color: rgb(224, 231, 14);
}

.navbar-brand:focus {
  color: rgb(224, 231, 14);
}
.nav-link:focus {
  color: rgb(224, 231, 14);
}

#Profile {
  padding-top: 80px;
}

#profile_image {
  padding-top: 40px;
}

#brief_profile_description {
  text-align: center;
  line-height: 3px;
}

#author {
  background-color: rgb(225, 72, 16);
}

.home_title {
  font-size: 28px;
  font-weight: 500;
}
.avatar-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center; /* Centers the whole block horizontally */
}
.avatar-container {
  /* Ensure container is square and circular */
  width: 200px;
  height: 200px;
  border-radius: 50%;

  /* Adds the border around the avatar */
  /* border: 3px solid #000000; */

  /* Ensures the image stays within the circle */
  overflow: hidden;

  /* Centers the image within the container */
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
